'use strict';

import React from 'react';
import {Route, IndexRoute, Redirect} from 'react-router';

import App            from './app';
/* list conferences and webinars */
import Main from './components/conferences/main';
/* specific conferences */
import Landing        from './components/conference/landing';
import Index          from './components/conference/index';
import Speakers       from './components/conference/speakers';
import Agendas        from './components/conference/agendas';
import Safety_Protocols from './components/conference/safety_protocols';
import Advisors       from './components/conference/advisors';
import Resources      from './components/conference/resources';
import Sponsors       from './components/conference/sponsors';
import Partners       from './components/conference/partners';
import Exhibitors     from './components/conference/exhibitors';
import Venues         from './components/conference/venues';
import Contact        from './components/conference/contact';
import Custom_Content from './components/conference/custom_content';
import Multimedia     from './components/conference/multimedia';
import Live_Stream    from './components/conference/live_stream';
import Register       from './components/conference/register';

// App

const routes = <Route path="/" component={App}>
    <Route path="webinars" component={Main}/>
    <Route path="conferences" component={Main}/>
    <Route path="conference/:conference_id/:year" component={Index} >
      <IndexRoute component={Landing} />
      <Route path="agenda" component={Agendas}>
        <Route path=":agenda_id" />
      </Route>
      <Route path="safety_protocols" component={Safety_Protocols} />
      <Route path="resources" component={Resources}>
        <Route path=":sponsor_id" />
      </Route>
      <Route path="venue" component={Venues}>
        <Route path=":venue_id" />
      </Route>
      <Route path="contact" component={Contact}/>
      <Route path="register" component={Register} />
      <Route path="multimedia" component={Multimedia} />
      <Route path="live_stream" component={Live_Stream} />
      <Route path="sponsors" component={Sponsors}>
        <Route path=":sponsor_id" />
      </Route>
      <Route path="partners" component={Partners}>
        <Route path=":partner_id" />
      </Route>
      <Route path="exhibitors" component={Exhibitors}>
        <Route path=":sponsor_id" />
      </Route>
      <Route path="speakers" component={Speakers} >
        <Route path=":speaker_id" />
      </Route>
      <Route path="advisors" component={Advisors} />
      <Route path="custom_content" component={Custom_Content}>
        <Route path=":custom_content_id" />
      </Route>
    </Route>
  </Route>

export default routes;
